import { Box, Tooltip, Typography, useTheme } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

const SalesProgressWarning = ({
  message,
  highlightText,
  highlightTooltip,
}: {
  message: string;
  highlightText?: string;
  highlightTooltip?: string;
}) => {
  const theme = useTheme();
  const warningColor =
    theme.nawy?.colors?.semantic?.layer?.extension?.warning ?? "#f79009";
  const bgColor =
    theme.nawy?.colors?.semantic?.layer?.extension?.warningLight ?? "#fef4e6";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: theme.nawy?.spacing?.sm,
        padding: `${theme.nawy?.spacing?.sm} ${theme.nawy?.spacing?.md}`,
        borderRadius: theme.nawy?.radius?.md,
        borderLeft: `4px solid ${warningColor}`,
        backgroundColor: bgColor,
        width: "100%",
      }}
    >
      <WarningAmberRoundedIcon
        sx={{
          fontSize: 20,
          color: warningColor,
          flexShrink: 0,
          marginTop: theme.nawy?.spacing?.xxxs,
        }}
      />
      <Typography
        component="span"
        sx={{
          ...theme.nawy?.typography?.english?.variants?.body?.sm?.regular,
          color: theme.nawy?.colors?.semantic?.text?.secondary,
          lineHeight: 1.5,
        }}
      >
        {highlightText ? (
          <>
            <Tooltip title={highlightTooltip || highlightText} arrow>
              <Typography
                component="span"
                sx={{
                  ...theme.nawy?.typography?.english?.variants?.body?.sm
                    ?.semibold,
                  color: theme.nawy?.colors?.semantic?.text?.primary,
                  cursor: "pointer",
                  maxWidth: "200px",
                  display: "inline-block",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  verticalAlign: "bottom",
                }}
              >
                {highlightText}
              </Typography>
            </Tooltip>{" "}
            {message}
          </>
        ) : (
          message
        )}
      </Typography>
    </Box>
  );
};

export default SalesProgressWarning;
